import controller from './DynamicComponentCtrl';

export default {
    controller: controller,
    bindings: {
        props: '<',
        name: '<',
        prefix: '@',
        variant: '<',
        suffix: '@',
        defaultName: '@',
        defaultVariant: '@'
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/DynamicComponent/index.js
// module id = 1621
// module chunks = 0